import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';
import PackerDeliveryOrderItem from './packerDeliveryOrderItem';

const PackerCombinedDeliveryOrderItemsTable = ({ combinedOrderItems, packedItemIds, setPackedItemIds }) => {
  const [batchIdOrderItemIds, setBatchIdOrderItemIds] = useState([]);

  const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

  return (
    <div>
      {combinedOrderItems.map((combinedOrderItem, itemIndex) => {
        const packedIndex = packedItemIds.findIndex((itemId) => itemId === combinedOrderItem.orderItem.item.id);
        const batchIdsIndex = batchIdOrderItemIds.findIndex((oiId) => oiId === combinedOrderItem.orderItem.id);

        return (
          <div className="striped-child p-a-3">
            <PackerDeliveryOrderItem
              key={itemIndex}
              item={combinedOrderItem.orderItem.item}
              onItemCheck={() => {
                const newPackedItemIds = packedItemIds.slice();
                if (packedIndex >= 0) {
                  newPackedItemIds.splice(packedIndex, 1);
                } else {
                  newPackedItemIds.push(combinedOrderItem.orderItem.item.id);
                }
                setPackedItemIds(newPackedItemIds);
              }}
              isPacked={packedIndex >= 0}
              quantity={combinedOrderItem.quantity}
              tempEnums={tempEnums}
            />
            <div>
              <small className="text-muted">
                {combinedOrderItem.orderItem.item.marketplaces.length
                  ? combinedOrderItem.orderItem.item.marketplaces[0].marketplaceName
                  : '-'}
              </small>
            </div>
            <div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const newBatchIdOrderItemIds = batchIdOrderItemIds.slice();
                  if (batchIdsIndex >= 0) {
                    newBatchIdOrderItemIds.splice(batchIdsIndex, 1);
                  } else {
                    newBatchIdOrderItemIds.push(combinedOrderItem.orderItem.id);
                  }

                  setBatchIdOrderItemIds(newBatchIdOrderItemIds);
                }}
                className="btn-small btn btn-normal-link"
              >
                <small>
                  <FormattedMessage
                    id={
                      batchIdsIndex >= 0
                        ? 'packer.delivery.day.marketplace.table.column.item.hide.orders'
                        : 'packer.delivery.day.marketplace.table.column.item.show.orders'
                    }
                  />
                </small>
              </button>
            </div>

            {batchIdsIndex >= 0 ? (
              <div>
                ---
                {combinedOrderItem.batchIds?.map((bid) => (
                  <div>{bid}</div>
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PackerCombinedDeliveryOrderItemsTable;
